import Vue from 'vue';
import { get as getDict } from '../../util/http';

export default class Dict {
  constructor(dict) {
    this.dict = dict;
  }

  async init(names, completeCallback) {
    if (names === undefined || name === null) {
      throw new Error('need Dict names');
    }
    const ps = [];
    ps.push(getDict('/server/dicDetail/listDetail', { dictName: names }).then(data => {
      for (const item in data) {
        this.dict[item] = [];
        this.dict[item].splice(0, 0, ...data[item]);
        this.dict.dict[item] = {};
        this.dict.label[item] = {};
        data[item].forEach(d => {
          Vue.set(this.dict.dict[item], d.value, d);
          Vue.set(this.dict.label[item], d.value, d.label);
        });
      }
    }));
    await Promise.all(ps);
    completeCallback();
  }
}
